import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaFlask, FaLaptopCode, FaCogs, FaMedkit, FaSolarPanel } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function STEMCoachingPrograms() {
  const stemPrograms = [
    { 
      name: "Science", 
      icon: <FaFlask size={48} />, 
      description: "Advanced scientific concepts and research methodologies",
      color: "#4CAF50",
      path: "/stem-science"
    },
    
    { 
      name: "Technology", 
      icon: <FaLaptopCode size={48} />, 
      description: "Cutting-edge technology and programming skills",
      color: "#2196F3",
      path: "/stem-technology"
    },
    
    { 
      name: "Engineering", 
      icon: <FaCogs size={48} />, 
      description: "Problem-solving and design principles",
      color: "#FF9800",
      path: "/stem-engineering"
    },

    { 
      name: "Medical", 
      icon: <FaMedkit size={48} />, 
      description: "Healthcare fundamentals and medical sciences",
      color: "#F44336",
      path: "/stem-medical"
    },

    { 
      name: "Energy Sector", 
      icon: <FaSolarPanel size={48} />,
      description: "Renewable energy and sustainability practices",
      color: "#673AB7",
      path: "/stem-energy"
    },
  ];

  return (
    <Container fluid className="py-3 px-3 px-md-1"  >
      {/* Header Section */}
      <Row className="justify-content-center text-center mb-3">
        <Col lg={8}>
          <h1 className="fw-bold mb-3">Our STEM + E Coaching Programs</h1>
          <p className="lead mb-2">Excellence in Science, Technology, Engineering, Medical & Renewable Energy/Oil & Mining Sector</p>
        </Col>
      </Row>

      {/* STEM Program Boxes */}
      <Row className="g-3 justify-content-center mb-2">
        {stemPrograms.map((program, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={4} xl={2} className="d-flex">
            <Card 
              as={Link}
              to={program.path}
              className="text-center h-100 w-100 border-0 text-decoration-none text-dark"
              style={{
                borderRadius: "15px",
                transition: "all 0.3s ease",
                cursor: "pointer",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                overflow: "hidden",
                backgroundColor: "white"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.1)";
                e.currentTarget.style.backgroundColor = `${program.color}05`;
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)";
                e.currentTarget.style.backgroundColor = "white";
              }}
            >
              <Card.Body className="d-flex flex-column align-items-center p-4">
                {/* Icon Section - Clearly on top */}
                <div 
                  className="mb-4 d-flex align-items-center justify-content-center"
                  style={{
                    color: program.color,
                    marginTop: "10px"
                  }}
                >
                  {program.icon}
                </div>
                
                {/* Divider */}
                <div 
                  className="w-25 mb-3" 
                  style={{ 
                    height: "3px", 
                    backgroundColor: program.color,
                    borderRadius: "2px"
                  }}
                ></div>
                
                {/* Text Content - Below the icon */}
                <Card.Title 
                  className="fw-bold mb-2"
                  style={{ fontSize: "1.25rem" }}
                >
                  {program.name}
                </Card.Title>
                
                <Card.Text className="text-muted mb-2" style={{ fontSize: "0.875rem" }}>
                  {program.description}
                </Card.Text>
                
                <div className="mt-auto">
                  <span 
                    className="d-inline-block mt-2" 
                    style={{ 
                      color: program.color, 
                      fontWeight: "600",
                      borderBottom: `2px solid ${program.color}`,
                      paddingBottom: "2px"
                    }}
                  >
                    Explore Course →
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
     </Container>
  );
}

